import { getFormControlValueAsString as o } from "./getFormControlValueAsString.js";
const e = (r) => {
  if (r !== void 0)
    return o(r);
};
export {
  e as getFormControlValueAsStringIfDefined
};
